import {
  FINISH_LOADING_APPLICATION,
  LOAD_TRANSLATED_TEXTS,
  RESET_TRANSLATED_TEXTS,
  START_LOADING_APPLICATION,
} from "../action";
import { getTranslatedTexts } from "../api/api";
import { EN_US_LOCALE } from "../utilities/constants";

export const loadTranslatedTexts =
  (localeValue = EN_US_LOCALE) =>
  async (dispatch) => {
    if (localeValue !== EN_US_LOCALE) {
      try {
        dispatch({ type: START_LOADING_APPLICATION });
        const data = await getTranslatedTexts(localeValue);
        const updatedData = Object.assign({}, data, { locale: localeValue });
        dispatch({ type: LOAD_TRANSLATED_TEXTS, payload: updatedData });
      } catch (error) {
        console.error("Error in loadTranslatedTexts:", error);
        throw error;
      } finally {
        dispatch({ type: FINISH_LOADING_APPLICATION });
      }
    } else {
      dispatch({ type: RESET_TRANSLATED_TEXTS });
    }
  };

export default loadTranslatedTexts;
